__turbopack_context__.v({
  "component": "style-module-scss-module__JFj1ga__component",
});
